import React, { PureComponent } from 'react'
import { string, func } from 'prop-types'
import DefaultComponentLayout, { LayoutContent } from '../../../Layout'

class CoppaConfirmation extends PureComponent {
  static propTypes = {
    guardianemail: string.isRequired,
    configureTrack: func.isRequired,
    Header: func,
  }

  static defaultProps = {
    Header: null,
  }

  componentDidMount() {
    const { configureTrack } = this.props
    configureTrack({
      eventName: 'ParentVerificationConfirm',
      widget: 'create_account',
      pageType: 'COPPA',
    })
  }

  render() {
    const {
      guardianemail,
      Header,
    } = this.props

    return (
      <DefaultComponentLayout nameSpace="passport__coppa__confirm" Header={Header}>
        <LayoutContent title message="passport.common.title.almostDone" />
        <LayoutContent subTitle message="passport.coppa.notice.thankYou" />
        <LayoutContent main>
          <div className="text-font-16 passport__pt20 font-weight-600 passport__wordbreak">
            {guardianemail}
          </div>
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default CoppaConfirmation
